import { Controller, RegisterOptions, useFormContext } from "react-hook-form";

import { Select, SelectProps } from "./Select";

type RhfTSelectProps<T> = Omit<SelectProps<T>, "onChange" | "value"> & {
  name: string;
  rhfOptions?: RegisterOptions;
  className?: string;
  defaultValue?: T | T[];
};

export const RhfSelect = <T extends string | number>(
  props: RhfTSelectProps<T>,
): JSX.Element => {
  const { register, formState } = useFormContext();

  register(props.name, props.rhfOptions);

  const isMultiple = props.multiple === true;

  return (
    <div className={props.className}>
      <Controller
        name={props.name}
        defaultValue={props.defaultValue ?? (isMultiple ? [] : "")}
        render={({ field }) => (
          <Select
            {...props}
            multiple={false}
            value={field.value as any}
            onChange={field.onChange}
          />
        )}
      />

      {
        <p className="text-xs text-red-500 mt-1 ml-1">
          {formState.errors[props.name]?.message?.toString() ?? ""}
        </p>
      }
    </div>
  );
};
